import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import { deleteActivity } from "../../actions/activity";
import useDropdownContext from "../../hooks/useDropdownContext";
import DropdownMenu from "../DropdownMenu";
import DropdownList from "../DropdownMenu/DropdownList";

type ActivityDropdownProps = {
  activityId: string;
  activityType: string;
  onOpenChange?: (open: boolean) => void;
};

const ActivityDropdown = ({
  activityId,
  activityType,
  onOpenChange,
}: ActivityDropdownProps) => {
  const context = useDropdownContext({
    activityId,
    activityType,
  });

  const actions = [deleteActivity];

  return (
    <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
      <DropdownMenu
        asChild={true}
        onOpenChange={onOpenChange}
        triggerComponent={
          <button
            type="button"
            aria-label="Open activity menu"
            className="p-2 group-hover:bg-gray-100 rounded-full"
          >
            <EllipsisVerticalIcon className="w-5 h-5 text-gray-600" />
          </button>
        }
      >
        <DropdownList actions={actions} context={context} />
      </DropdownMenu>
    </div>
  );
};

export default ActivityDropdown;
